import React, { useEffect, useState } from 'react';
import style from './AlertsMainPage.module.css';

import { AlertsHeader } from '../components/alertsheader/AlertsHeader';
import { AlertsGridLayoutContainer } from '../components/gridLayout/AlertsGridLayoutContainer';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import {
  AlertsStore,
  AlertStoreProvider,
} from '../../../../stores/websocketStore/_alertsStore';
import { observer } from 'mobx-react-lite';
import { ConnectBrokerageModal } from '../../notifications/tradierLoginModal/ConnectBrokerageModal';

export const AlertsMainPage = observer(() => {
  const websocketStore = useWebsocketStore();
  const loggedIn = websocketStore.tradierLoginStore?.loggedIn ?? null;
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [alertsStore] = useState(() => new AlertsStore(websocketStore));
  useEffect(() => {
    if (loggedIn !== null) {
      if (loggedIn === false) {
        setOpenLoginModal(true);
      }
      if (loggedIn === true) {
        setOpenLoginModal(false);
      }
    }
  }, [loggedIn]);
  
  return (
    <AlertStoreProvider store={alertsStore}>
      <ConnectBrokerageModal
        open={openLoginModal}
        handleClose={() => setOpenLoginModal(false)}
        page="ALERTS"
      />
      <div className={style.outerContainer}>
        <AlertsHeader />
        <div className={style.body}>
          <AlertsGridLayoutContainer />
        </div>
      </div>
    </AlertStoreProvider>
  );
});
